import CardCount from "src/components/CardCount";

interface HeaderCardsProps {
  filterByType: string;
  handleSelectTripFilterByType?: (type: string) => void;
  dashboard: {
    allTrips: number;
    scheduled: number;
    new: number;
    pending: number;
    refused: number;
    canceled: number;
    acomplished: number;
  };
}

export const HeaderCards = ({ filterByType, handleSelectTripFilterByType, dashboard }: HeaderCardsProps) => {
  return (
    <div style={{ display: "flex", gap: 20 }}>
      <CardCount
        isActive={filterByType === 'ALL'}
        onClick={() => handleSelectTripFilterByType?.('ALL')}
        borderColor="#00C2DF"
        label="TODAS AS VIAGENS"
        value={dashboard.allTrips}
      />
      <CardCount
        isActive={filterByType === 'ACCEPTED'}
        onClick={() => handleSelectTripFilterByType?.('ACCEPTED')}
        borderColor="#5CB85C"
        label="VIAGENS AGENDADAS"
        value={dashboard.scheduled}
      />
      <CardCount
        isActive={filterByType === 'PROPOSED'}
        onClick={() => handleSelectTripFilterByType?.('PROPOSED')}
        borderColor="#FF8E3C"
        label="NOVAS PROPOSTAS"
        value={dashboard.new}
      />
      <CardCount
        isActive={filterByType === 'PENDING'}
        onClick={() => handleSelectTripFilterByType?.('PENDING')}
        borderColor="#D0D8DE"
        label="ACEITE PENDENTE"
        value={dashboard.pending}
      />
      <CardCount
        isActive={filterByType === 'REFUSED'}
        onClick={() => handleSelectTripFilterByType?.('REFUSED')}
        borderColor="#D90000"
        label="VIAGENS RECUSADAS"
        value={dashboard.refused}
      />
      <CardCount
        isActive={filterByType === 'CANCELED'}
        onClick={() => handleSelectTripFilterByType?.('CANCELED')}
        borderColor="#D90000"
        label="VIAGENS CANCELADAS"
        value={dashboard.canceled}
      />
      <CardCount
        isActive={filterByType === 'ACOMPLISHED'}
        onClick={() => handleSelectTripFilterByType?.('ACOMPLISHED')}
        borderColor="#5CB85C"
        label="VIAGENS CONCLUÍDAS"
        value={dashboard.acomplished}
      />
    </div>
  )
};
